var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.buttons.length)?_c('RideContextMenu',_vm._b({attrs:{"buttons":_vm.buttons}},'RideContextMenu',_vm.$attrs,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }